export default __webpack_public_path__ + "static/media/remove_text_icon.31913800.svg";